import { css } from "@emotion/react"
import { palette } from '~/utils/colors'

export const card = css`
    display: flex;
    gap: 12px;
`;

export const thumbnail = css`
    width: 44px;
    height: 44px;
`;

export const title = css`
    color: ${palette.text.primary};
    font-size: 1.3rem;
    font-weight: bold;
    line-height: 20px;
`;

export const time = css`
    color: ${palette.text.secondary};
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 20px;
`;

export const category = css`
    margin-left: 8px;
	color: ${palette.text.secondary};
	font-size: 1.2rem;
	font-weight: 500;
	line-height: 20px;
`;